<template>

    <div>
        <div class="my-2">
            <div class="mt-3">
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Select {{getActiveCanvasObjProps.id.split('_')[1]}} topic
                </label>
                <select @change="onChange($event)" type="text" class="form-control ">

                    <option v-for="(option, index) of list[getActiveCanvasObjProps.id.split('_')[1]]" v-bind:key="index" :value="option.value">{{option.label}}</option>

                </select>
            </div>
        </div>
        <div class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Header Color
                    </label>

                    <input type="color" @change="onColorChange($event)" name="headerColor" class="custonInput" :value="headerColor" /> 
                </div> 
            </div>
        </div> 
        <div class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Summary Color
                    </label>

                    <input type="color" @change="onColorChange($event)" name="summaryColor" class="custonInput" :value="summaryColor" /> 
                </div> 
            </div>
        </div> 
        <div class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        background Color
                    </label>

                    <input type="color" @change="onColorChange($event)" name="backgroundColor" class="custonInput" :value="backgroundColor" /> 
                </div> 
            </div>
        </div> 
        <IncedecInput :defValue="postDelay" :getValue="onInputChange" paddingClass="px-0" marginClass="mt-3" label="Next Post Delay" sublabel="(SECONDS)" />

       
    </div>
</template>
<script>
import IncedecInput from "../../../components/incedecInput.vue" ;


const newsType = {
    "Aljazeera" : [{ value: "https://www.aljazeera.com/xml/rss/all.xml" , label:"Top Stories"}],
    "BBC" : [
                { value: "https://feeds.bbci.co.uk/news/rss.xml", label: "Top Stories" },
                { value: "https://feeds.bbci.co.uk/news/world/rss.xml", label: "World" },
                { value: "https://feeds.bbci.co.uk/news/uk/rss.xml", label: "UK" },
                { value: "https://feeds.bbci.co.uk/news/business/rss.xml", label: "Business" },
                { value: "https://feeds.bbci.co.uk/news/politics/rss.xml", label: "Politics" },
                { value: "https://feeds.bbci.co.uk/news/health/rss.xml", label: "Health" },
                { value: "https://feeds.bbci.co.uk/news/education/rss.xml", label: "Education" },
                { value: "https://feeds.bbci.co.uk/news/science_and_environment/rss.xml", label: "Science and Environment" },
                { value: "https://feeds.bbci.co.uk/news/technology/rss.xml", label: "Technology" },
                { value: "https://feeds.bbci.co.uk/news/entertainment_and_arts/rss.xml", label: "Entertainment and Arts" },
            ],
    "Clarin" :  [
        { value: "https://www.clarin.com/rss/lo-ultimo/" , label:"Lo Último"},
        { value: "https://www.clarin.com/rss/politica/" , label:"Política"},
        { value: "https://www.clarin.com/rss/mundo/" , label:"Mundo"},
        { value: "https://www.clarin.com/rss/sociedad/" , label:"Sociedad"},
        { value: "https://www.clarin.com/rss/policiales/" , label:"Policiales"},
        { value: "https://www.clarin.com/rss/ciudades/" , label:"Ciudades"},
        { value: "https://www.clarin.com/rss/opinion/" , label:"Opinión"},
        { value: "https://www.clarin.com/rss/cartas_al_pais/" , label:"Cartas al país"},
        { value: "https://www.clarin.com/rss/cultura/" , label:"Cultura"},
        { value: "https://www.clarin.com/rss/rural/" , label:"Rural"},
        { value: "https://www.clarin.com/rss/economia/" , label:"Economia"},
        { value: "https://www.clarin.com/rss/tecnologia/" , label:"Tecnologia"},
        { value: "https://www.clarin.com/rss/revista-enie/" , label:"Revista Ñ"},
        { value: "https://www.clarin.com/rss/viva/" , label:"Viva"},
        { value: "https://www.clarin.com/rss/br/" , label:"Clarín em Portugués"},
        { value: "https://www.clarin.com/rss/deportes/futbol/" , label:"Fútbol"},
        { value: "https://www.clarin.com/rss/deportes/ascenso/" , label:"Ascenso"},
        { value: "https://www.clarin.com/rss/deportes/futbol-internacional/" , label:"Fútbol Internacional"},
        { value: "https://www.clarin.com/rss/deportes/messi/" , label:"Messi"},
        { value: "https://www.clarin.com/rss/deportes/rugby/" , label:"Rugby"},
        { value: "https://www.clarin.com/rss/deportes/tenis/" , label:"Tenis"},
        { value: "https://www.clarin.com/rss/deportes/automovilismo/" , label:"Automovilismo"},
        { value: "https://www.clarin.com/rss/deportes/basquet/" , label:"Básquet"},
        { value: "https://www.clarin.com/rss/deportes/polideportivo/" , label:"Polideportivo"},
        { value: "https://www.clarin.com/rss/deportes/turf/" , label:"Turf"},
        { value: "https://www.clarin.com/rss/deportes/boxeo/" , label:"Boxeo"},
        { value: "https://www.clarin.com/rss/deportes/hockey/" , label:"Hockey"},
        { value: "https://www.clarin.com/rss/deportes/" , label:"Deportes"},
        { value: "https://www.clarin.com/rss/espectaculos/fama/" , label:"Fama"},
        { value: "https://www.clarin.com/rss/espectaculos/tv/" , label:"TV"},
        { value: "https://www.clarin.com/rss/espectaculos/cine/" , label:"Cine"},
        { value: "https://www.clarin.com/rss/espectaculos/musica/" , label:"Música"},
        { value: "https://www.clarin.com/rss/espectaculos/teatro/" , label:"Teatro"},
        { value: "https://www.clarin.com/rss/si/" , label:"S!"},
        { value: "https://www.clarin.com/rss/espectaculos/" , label:"Espectaculos"},
        { value: "https://www.clarin.com/rss/entremujeres/" , label:"Entremujeres"},
        { value: "https://www.clarin.com/rss/autos/" , label:"Autos"},
        { value: "https://www.clarin.com/rss/buena-vida/" , label:"Buena Vida"},
        { value: "https://www.clarin.com/rss/viajes/" , label:"Viajes"},
        { value: "https://www.clarin.com/rss/arq/" , label:"ARQ"},
       
],
    "CNN" :  [
        { value: "http://rss.cnn.com/rss/cnn_latest.rss" , label:"Most Recent"},
        { value: "http://rss.cnn.com/rss/edition.rss" , label:"Top Stories"},
        { value: "http://rss.cnn.com/rss/edition_world.rss" , label:"World"},
        { value: "http://rss.cnn.com/rss/edition_us.rss" , label:"U.S"},
        { value: "http://rss.cnn.com/rss/edition_technology.rss" , label:"Technology"},
        { value: "http://rss.cnn.com/rss/money_topstories.rss" , label:"Money"},
        { value: "http://rss.cnn.com/rss/edition_entertainment.rss" , label:"Entertainment"},
        { value: "http://rss.cnn.com/rss/cnn_health.rss" , label:"Health"},
        { value: "http://rss.cnn.com/rss/cnn_travel.rss" , label:"Travel"},
        { value: "http://rss.cnn.com/rss/edition_sport.rss" , label:"World Sport"},
        { value: "http://rss.cnn.com/rss/edition_football.rss" , label:"Football"},
        { value: "http://rss.cnn.com/rss/edition_motorsport.rss" , label:"Motorsport"},
],
    "ESPN" : [
            { value: "http://www.espn.com/espn/rss/news" , label:"Top Headlines"},
            { value: "http://www.espn.com/espn/rss/nfl/news" , label:"NFL Headlines"},
            { value: "http://www.espn.com/espn/rss/nba/news" , label:"NBA Headlines"},
            { value: "http://www.espn.com/espn/rss/mlb/news" , label:"MLB Headlines"},
            { value: "http://www.espn.com/espn/rss/nhl/news" , label:"NHL Headlines"},
            { value: "http://www.espn.com/espn/rss/rpm/news" , label:"Motorsports Headlines"},
            { value: "http://www.espn.com/espn/rss/espnu/news" , label:"ESPNU"},
            { value: "http://www.espn.com/espn/rss/ncb/news" , label:"College Basketball Headlines"},
            { value: "http://www.espn.com/espn/rss/ncf/news" , label:"College Football Headlines"},

    ],
    "Fox" : [
            { value: "http://feeds.foxnews.com/foxnews/latest" , label:"Latest Headlines"},
            { value: "http://feeds.foxnews.com/foxnews/most-popular" , label:"Most Popular"},
            { value: "http://feeds.foxnews.com/foxnews/entertainment" , label:"Entertainment"},
            { value: "http://feeds.foxnews.com/foxnews/health" , label:"Health"},
            { value: "http://feeds.foxnews.com/foxnews/section/lifestyle" , label:"Lifestyle"},
            { value: "http://feeds.foxnews.com/foxnews/opinion" , label:"Opinion"},
            { value: "http://feeds.foxnews.com/foxnews/politics" , label:"Politics"},
            { value: "http://feeds.foxnews.com/foxnews/science" , label:"Science"},
            { value: "http://feeds.foxnews.com/foxnews/sports" , label:"Sports"},
            { value: "http://feeds.foxnews.com/foxnews/tech" , label:"Tech"},
            { value: "http://feeds.foxnews.com/foxnews/national" , label:"U.S"},
            { value: "http://feeds.foxnews.com/foxnews/world" , label:"World"},
        
    ],
    "Google" : [
                { value: "https://news.google.com/news/rss" , label:"Top Stories"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/WORLD" , label:"World"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/NATION" , label:"Nation"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/BUSINESS" , label:"Business"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/TECHNOLOGY" , label:"Technology"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/ENTERTAINMENT" , label:"Entertainment"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/SPORTS" , label:"Sports"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/SCIENCE" , label:"Science"},
                { value: "https://news.google.com/news/rss/headlines/section/topic/HEALTH" , label:"Health"},
    ],
    "NTV" : [
        { value: "https://www.n-tv.de/rss" , label:"Topmeldungen aus allen Ressorts"},
        { value: "https://www.n-tv.de/politik/rss" , label:"Topmeldungen aus der Politik"},
        { value: "https://www.n-tv.de/wirtschaft/rssl" , label:"Topmeldungen aus Wirtschaft & Börse"},
    ],
    "WWD" : [
             { value: "https://wwd.com/custom-feed/recent-stories/" , label:"Recent Stories"},
             { value: "https://wwd.com/custom-feed/fashion/" , label:"Fashion"},
             { value: "https://wwd.com/custom-feed/fashion-shows/" , label:"Fashion Shows"},
             { value: "https://wwd.com/custom-feed/accessories/" , label:"Accessories"},
             { value: "https://wwd.com/custom-feed/beauty/" , label:"Beauty"},
             { value: "https://wwd.com/custom-feed/business/" , label:"Business"},
             { value: "https://wwd.com/custom-feed/eye/" , label:"Eye"},
             { value: "https://wwd.com/custom-feed/fashion-scoops/" , label:"Fashion Scoops"},
             { value: "https://wwd.com/custom-feed/mens/" , label:"Men’s"},
             { value: "http://footwearnews.com/custom-feed/recent-stories/" , label:"Footwear News"},
             
    ],
    "Yahoo" : [
        { value: "https://news.yahoo.com/rss/" , label:"Top Stories"},
        { value: "https://finance.yahoo.com/rss/topstories" , label:"Finance"},
        { value: "https://news.yahoo.com/rss/entertainment" , label:"Entertainment"},
        { value: "https://news.yahoo.com/rss/politics" , label:"Politics"},
        { value: "https://news.yahoo.com/rss/sports" , label:"Sports"},
    ],
}

export default {
    name: "NewsAppSettings",
    data() {
        return {
            list: newsType,
            postDelay:10,
            headerColor:"",
            backgroundColor:"",
            summaryColor:"",
        };
    },
    watch:{
        getActiveCanvasObjProps :{
          handler(updatedValues) {
            
            // this.lineheight = updatedValues.lineHeight;
           
            this.summaryColor = updatedValues.summaryColor;
            this.backgroundColor = updatedValues.backgroundColor;
            this.headerColor = updatedValues.headerColor;
                console.log(updatedValues)
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        getActiveCanvasObjProps() {
            return this.$store.getters.getActiveObjectprops;
        },
    },
    components: { IncedecInput },
    methods:{
        onChange(e){
            this.$store.dispatch("setCurrentObjectProperties" , { url:  e.target.value })
        },
        onColorChange(e){
            this.$store.dispatch("setCurrentObjectProperties" , { [e.target.name]:  e.target.value })
        },
        onInputChange(value){
            console.log(value)

        }
    }
}
</script>

<style scoped>
.custonInput {
    padding: 0;
    width: 50px;
    color: #495057;
    border-radius: 3px;
    height: 40px;
    outline: none;
    background: none;
    border: none;
}
</style>